import type { OneTimeProduct, AssertProduct } from '@/store/products'

declare const _prd_AfSybFOCKt9M: {
	id: 'prd_AfSyb2DEV2FOCKt9M'
	ident: 'prd_AfSybFOCKt9M'
	sku: 'simple_workbook_bundle_35_usd'
	type: 'one_time'
	price: {
		price_id: 'prc_Ryhfa2DEV2lICM2as'
		amount: 64
		amount_usd: 35
		currency: 'USD'
		amount_with_discount: 35
		discount: 29
		promocode: 'BASE'
	}
}
type _check = AssertProduct<typeof _prd_AfSybFOCKt9M, OneTimeProduct>
const prd_AfSybFOCKt9M = { ident: 'prd_AfSybFOCKt9M' } as typeof _prd_AfSybFOCKt9M

export default prd_AfSybFOCKt9M
